/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  ApiError,
  GetTwitchClipsResponse,
  LiveStreamsResponse,
  StreamEmbedResponse,
  StreamStatusResponse,
  StreamViewEventBody,
  StreamViewEventResponse,
  StreamingPlatform,
  ValidateStreamConfigBody,
  ValidateStreamConfigResponse,
} from '../models/index';
import {
    ApiErrorFromJSON,
    ApiErrorToJSON,
    GetTwitchClipsResponseFromJSON,
    GetTwitchClipsResponseToJSON,
    LiveStreamsResponseFromJSON,
    LiveStreamsResponseToJSON,
    StreamEmbedResponseFromJSON,
    StreamEmbedResponseToJSON,
    StreamStatusResponseFromJSON,
    StreamStatusResponseToJSON,
    StreamViewEventBodyFromJSON,
    StreamViewEventBodyToJSON,
    StreamViewEventResponseFromJSON,
    StreamViewEventResponseToJSON,
    StreamingPlatformFromJSON,
    StreamingPlatformToJSON,
    ValidateStreamConfigBodyFromJSON,
    ValidateStreamConfigBodyToJSON,
    ValidateStreamConfigResponseFromJSON,
    ValidateStreamConfigResponseToJSON,
} from '../models/index';

export interface CreateStreamsValidateRequest {
    validateStreamConfigBody: ValidateStreamConfigBody;
}

export interface CreateStreamsViewEventRequest {
    streamViewEventBody: StreamViewEventBody;
}

export interface GetStreamsClipsRequest {
    channels: string;
    limit?: number;
}

export interface GetStreamsEmbedRequest {
    platform: GetStreamsEmbedPlatformEnum;
    twitchChannelId?: string;
    kickChannelSlug?: string;
    youtubeChannelId?: string;
    youtubeLiveId?: string;
    parentDomain?: string;
}

export interface GetStreamsLiveRequest {
    platform?: StreamingPlatform;
    competitionType?: string;
    minViewers?: number;
    limit?: number;
    offset?: number;
}

export interface GetStreamsStatusRequest {
    platform: GetStreamsStatusPlatformEnum;
    twitchChannelId?: string;
    kickChannelSlug?: string;
    youtubeChannelId?: string;
    youtubeLiveId?: string;
}

/**
 * StreamingApi - interface
 * 
 * @export
 * @interface StreamingApiInterface
 */
export interface StreamingApiInterface {
    /**
     * Validate a stream configuration
     * @param {ValidateStreamConfigBody} validateStreamConfigBody 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StreamingApiInterface
     */
    createStreamsValidateRaw(requestParameters: CreateStreamsValidateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ValidateStreamConfigResponse>>;

    /**
     * Validate a stream configuration
     */
    createStreamsValidate(requestParameters: CreateStreamsValidateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ValidateStreamConfigResponse>;

    /**
     * Track stream viewing — \"start\" when watching begins, \"heartbeat\" periodically while watching, \"end\" when it stops.
     * @param {StreamViewEventBody} streamViewEventBody 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StreamingApiInterface
     */
    createStreamsViewEventRaw(requestParameters: CreateStreamsViewEventRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<StreamViewEventResponse>>;

    /**
     * Track stream viewing — \"start\" when watching begins, \"heartbeat\" periodically while watching, \"end\" when it stops.
     */
    createStreamsViewEvent(requestParameters: CreateStreamsViewEventRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<StreamViewEventResponse>;

    /**
     * Fetches recent top clips from the specified Twitch channels, merged and sorted by view count.
     * @summary Get Twitch clips from featured creators
     * @param {string} channels Comma-separated Twitch channel login names (e.g., \&quot;aydan,symfuhny,huskerrs\&quot;)
     * @param {number} [limit] Total number of clips to return (max 50)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StreamingApiInterface
     */
    getStreamsClipsRaw(requestParameters: GetStreamsClipsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetTwitchClipsResponse>>;

    /**
     * Fetches recent top clips from the specified Twitch channels, merged and sorted by view count.
     * Get Twitch clips from featured creators
     */
    getStreamsClips(requestParameters: GetStreamsClipsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetTwitchClipsResponse>;

    /**
     * Get embed configuration for displaying a stream
     * @param {'TWITCH' | 'YOUTUBE' | 'KICK'} platform Streaming platform (TWITCH, YOUTUBE, KICK)
     * @param {string} [twitchChannelId] Twitch channel login name
     * @param {string} [kickChannelSlug] Kick channel slug (username)
     * @param {string} [youtubeChannelId] YouTube channel ID
     * @param {string} [youtubeLiveId] YouTube live video ID
     * @param {string} [parentDomain] Parent domain for embed (required by Twitch)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StreamingApiInterface
     */
    getStreamsEmbedRaw(requestParameters: GetStreamsEmbedRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<StreamEmbedResponse>>;

    /**
     * Get embed configuration for displaying a stream
     */
    getStreamsEmbed(requestParameters: GetStreamsEmbedRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<StreamEmbedResponse>;

    /**
     * Get all live streams across DevourPlay competitions
     * @param {StreamingPlatform} [platform] 
     * @param {string} [competitionType] 
     * @param {number} [minViewers] 
     * @param {number} [limit] 
     * @param {number} [offset] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StreamingApiInterface
     */
    getStreamsLiveRaw(requestParameters: GetStreamsLiveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<LiveStreamsResponse>>;

    /**
     * Get all live streams across DevourPlay competitions
     */
    getStreamsLive(requestParameters: GetStreamsLiveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<LiveStreamsResponse>;

    /**
     * Check if a stream is live on a supported platform
     * @param {'TWITCH' | 'YOUTUBE' | 'KICK' | 'MULTI'} platform Streaming platform (TWITCH, YOUTUBE, KICK, MULTI)
     * @param {string} [twitchChannelId] Twitch channel login name or ID
     * @param {string} [kickChannelSlug] Kick channel slug (username)
     * @param {string} [youtubeChannelId] YouTube channel ID (starts with UC)
     * @param {string} [youtubeLiveId] YouTube live video ID (if known)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StreamingApiInterface
     */
    getStreamsStatusRaw(requestParameters: GetStreamsStatusRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<StreamStatusResponse>>;

    /**
     * Check if a stream is live on a supported platform
     */
    getStreamsStatus(requestParameters: GetStreamsStatusRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<StreamStatusResponse>;

}

/**
 * 
 */
export class StreamingApi extends runtime.BaseAPI implements StreamingApiInterface {

    /**
     * Validate a stream configuration
     */
    async createStreamsValidateRaw(requestParameters: CreateStreamsValidateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ValidateStreamConfigResponse>> {
        if (requestParameters['validateStreamConfigBody'] == null) {
            throw new runtime.RequiredError(
                'validateStreamConfigBody',
                'Required parameter "validateStreamConfigBody" was null or undefined when calling createStreamsValidate().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Admin", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/streams/validate`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ValidateStreamConfigBodyToJSON(requestParameters['validateStreamConfigBody']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ValidateStreamConfigResponseFromJSON(jsonValue));
    }

    /**
     * Validate a stream configuration
     */
    async createStreamsValidate(requestParameters: CreateStreamsValidateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ValidateStreamConfigResponse> {
        const response = await this.createStreamsValidateRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Track stream viewing — \"start\" when watching begins, \"heartbeat\" periodically while watching, \"end\" when it stops.
     */
    async createStreamsViewEventRaw(requestParameters: CreateStreamsViewEventRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<StreamViewEventResponse>> {
        if (requestParameters['streamViewEventBody'] == null) {
            throw new runtime.RequiredError(
                'streamViewEventBody',
                'Required parameter "streamViewEventBody" was null or undefined when calling createStreamsViewEvent().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("User", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/streams/view-event`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: StreamViewEventBodyToJSON(requestParameters['streamViewEventBody']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => StreamViewEventResponseFromJSON(jsonValue));
    }

    /**
     * Track stream viewing — \"start\" when watching begins, \"heartbeat\" periodically while watching, \"end\" when it stops.
     */
    async createStreamsViewEvent(requestParameters: CreateStreamsViewEventRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<StreamViewEventResponse> {
        const response = await this.createStreamsViewEventRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Fetches recent top clips from the specified Twitch channels, merged and sorted by view count.
     * Get Twitch clips from featured creators
     */
    async getStreamsClipsRaw(requestParameters: GetStreamsClipsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetTwitchClipsResponse>> {
        if (requestParameters['channels'] == null) {
            throw new runtime.RequiredError(
                'channels',
                'Required parameter "channels" was null or undefined when calling getStreamsClips().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['channels'] != null) {
            queryParameters['channels'] = requestParameters['channels'];
        }

        if (requestParameters['limit'] != null) {
            queryParameters['limit'] = requestParameters['limit'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("User", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/streams/clips`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetTwitchClipsResponseFromJSON(jsonValue));
    }

    /**
     * Fetches recent top clips from the specified Twitch channels, merged and sorted by view count.
     * Get Twitch clips from featured creators
     */
    async getStreamsClips(requestParameters: GetStreamsClipsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetTwitchClipsResponse> {
        const response = await this.getStreamsClipsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get embed configuration for displaying a stream
     */
    async getStreamsEmbedRaw(requestParameters: GetStreamsEmbedRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<StreamEmbedResponse>> {
        if (requestParameters['platform'] == null) {
            throw new runtime.RequiredError(
                'platform',
                'Required parameter "platform" was null or undefined when calling getStreamsEmbed().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['platform'] != null) {
            queryParameters['platform'] = requestParameters['platform'];
        }

        if (requestParameters['twitchChannelId'] != null) {
            queryParameters['twitchChannelId'] = requestParameters['twitchChannelId'];
        }

        if (requestParameters['kickChannelSlug'] != null) {
            queryParameters['kickChannelSlug'] = requestParameters['kickChannelSlug'];
        }

        if (requestParameters['youtubeChannelId'] != null) {
            queryParameters['youtubeChannelId'] = requestParameters['youtubeChannelId'];
        }

        if (requestParameters['youtubeLiveId'] != null) {
            queryParameters['youtubeLiveId'] = requestParameters['youtubeLiveId'];
        }

        if (requestParameters['parentDomain'] != null) {
            queryParameters['parentDomain'] = requestParameters['parentDomain'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/streams/embed`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => StreamEmbedResponseFromJSON(jsonValue));
    }

    /**
     * Get embed configuration for displaying a stream
     */
    async getStreamsEmbed(requestParameters: GetStreamsEmbedRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<StreamEmbedResponse> {
        const response = await this.getStreamsEmbedRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get all live streams across DevourPlay competitions
     */
    async getStreamsLiveRaw(requestParameters: GetStreamsLiveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<LiveStreamsResponse>> {
        const queryParameters: any = {};

        if (requestParameters['platform'] != null) {
            queryParameters['platform'] = requestParameters['platform'];
        }

        if (requestParameters['competitionType'] != null) {
            queryParameters['competitionType'] = requestParameters['competitionType'];
        }

        if (requestParameters['minViewers'] != null) {
            queryParameters['minViewers'] = requestParameters['minViewers'];
        }

        if (requestParameters['limit'] != null) {
            queryParameters['limit'] = requestParameters['limit'];
        }

        if (requestParameters['offset'] != null) {
            queryParameters['offset'] = requestParameters['offset'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("User", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/streams/live`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => LiveStreamsResponseFromJSON(jsonValue));
    }

    /**
     * Get all live streams across DevourPlay competitions
     */
    async getStreamsLive(requestParameters: GetStreamsLiveRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<LiveStreamsResponse> {
        const response = await this.getStreamsLiveRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Check if a stream is live on a supported platform
     */
    async getStreamsStatusRaw(requestParameters: GetStreamsStatusRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<StreamStatusResponse>> {
        if (requestParameters['platform'] == null) {
            throw new runtime.RequiredError(
                'platform',
                'Required parameter "platform" was null or undefined when calling getStreamsStatus().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['platform'] != null) {
            queryParameters['platform'] = requestParameters['platform'];
        }

        if (requestParameters['twitchChannelId'] != null) {
            queryParameters['twitchChannelId'] = requestParameters['twitchChannelId'];
        }

        if (requestParameters['kickChannelSlug'] != null) {
            queryParameters['kickChannelSlug'] = requestParameters['kickChannelSlug'];
        }

        if (requestParameters['youtubeChannelId'] != null) {
            queryParameters['youtubeChannelId'] = requestParameters['youtubeChannelId'];
        }

        if (requestParameters['youtubeLiveId'] != null) {
            queryParameters['youtubeLiveId'] = requestParameters['youtubeLiveId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/streams/status`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => StreamStatusResponseFromJSON(jsonValue));
    }

    /**
     * Check if a stream is live on a supported platform
     */
    async getStreamsStatus(requestParameters: GetStreamsStatusRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<StreamStatusResponse> {
        const response = await this.getStreamsStatusRaw(requestParameters, initOverrides);
        return await response.value();
    }

}

/**
 * @export
 */
export const GetStreamsEmbedPlatformEnum = {
    Twitch: 'TWITCH',
    Youtube: 'YOUTUBE',
    Kick: 'KICK'
} as const;
export type GetStreamsEmbedPlatformEnum = typeof GetStreamsEmbedPlatformEnum[keyof typeof GetStreamsEmbedPlatformEnum];
/**
 * @export
 */
export const GetStreamsStatusPlatformEnum = {
    Twitch: 'TWITCH',
    Youtube: 'YOUTUBE',
    Kick: 'KICK',
    Multi: 'MULTI'
} as const;
export type GetStreamsStatusPlatformEnum = typeof GetStreamsStatusPlatformEnum[keyof typeof GetStreamsStatusPlatformEnum];
